import { render, staticRenderFns } from "./recordingShareDrop.vue?vue&type=template&id=21096958&scoped=true&"
import script from "./recordingShareDrop.vue?vue&type=script&lang=js&"
export * from "./recordingShareDrop.vue?vue&type=script&lang=js&"
import style0 from "./recordingShareDrop.vue?vue&type=style&index=0&id=21096958&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21096958",
  null
  
)

export default component.exports